<template>
    <div>
        <CommonPopupFrame :changeBottom="0" :changeHeight="90" :isOpen="isOpen" :closeCompleteAction="() => { closeCompleteAction(PROFILE_BOX_LIST.VISIT_REASONS, true, false, false) }">
            <div style="width: 36px; height: 5px; background-color: #d9d9d9; margin: 0 auto; border-radius: 5px; margin-top: 5px"></div>
            <div @click="closeCompleteAction(PROFILE_BOX_LIST.VISIT_REASONS, true, false, false)" style="padding-left: 12px; margin-top: 6px; font-weight: 700; color: #808080; height: 30px; width: 50px;">닫기</div>
            <div @touchmove.stop="() => { }" style="margin-top: 31px; flex: 1; overflow-y: scroll; padding: 0 12px; padding-bottom: 20px;">
                <div style="text-align: center;">
                    <div style="font-weight: 700; font-size: 32px; line-height: 46px;">이용 목적</div>
                    <div style="margin-top: 15px; font-weight: 500; line-height: 24px;">이용 목적에 따라 사용 범위가 달라지며<br>전문가의 도움을 다양하게 받을 수 있습니다</div>
                </div>
                <div style="margin-top: 40px;">
                    <div style="font-weight: 500; font-size: 14px; margin-bottom: 4px; line-height: 24px;">축구선수가 되기</div>
                    <div style="display: flex; flex-wrap: wrap; gap: 12px;">
                        <div @click="setSelectVisitReason(each)" :class="selectVisitReason === each ? 'active' : ''" v-for="each, i in foward" :key="i" style="padding: 12px 20px; border-radius: 24px; line-height: 24px; font-weight: 500; text-align: center; border: 1px solid #d9d9d9; font-size: 14px;">
                            {{ each }}
                        </div>
                    </div>
                </div>
                <div style="margin-top: 16px;">
                    <div style="font-weight: 500; font-size: 14px; margin-bottom: 4px; line-height: 24px;">축구 배우기</div>
                    <div style="display: flex; flex-wrap: wrap; gap: 12px;">
                        <div @click="setSelectVisitReason(each)" :class="selectVisitReason === each ? 'active' : ''" v-for="each, i in midfielder" :key="i" style="padding: 12px 20px; border-radius: 24px; line-height: 24px; font-weight: 500; text-align: center; border: 1px solid #d9d9d9; font-size: 14px;">
                            {{ each }}
                        </div>
                    </div>
                </div>
                <div style="margin-top: 16px;">
                    <div style="font-weight: 500; font-size: 14px; margin-bottom: 4px; line-height: 24px;">취미</div>
                    <div style="display: flex; flex-wrap: wrap; gap: 12px;">
                        <div @click="setSelectVisitReason(each)" :class="selectVisitReason === each ? 'active' : ''" v-for="each, i in defense_n_keeper" :key="i" style="padding: 12px 20px; border-radius: 24px; line-height: 24px; font-weight: 500; text-align: center; border: 1px solid #d9d9d9; font-size: 14px;">
                            {{ each }}
                        </div>
                    </div>
                </div>
            </div>
            <div style="height: 90px; padding: 0 12px;">
                <div @click="save" v-if="selectVisitReason !== ''" class="save_btn_active">저장하기</div>
                <div v-else class="save_btn_unactive">저장하기</div>
            </div>
        </CommonPopupFrame>
    </div>
</template>

<script>
import CommonPopupFrame from '@/components/modal/my/CommonPopupFrame'
import ResponseCode from '../../ResponseCode'
import { PROFILE_BOX_LIST } from '@/Constants'

export default {
    name: 'SettingPlayStyle',
    components: { CommonPopupFrame },
    props: {
        isOpen: {
            type: Boolean,
            default: false,
        },
        closeCompleteAction: {
            type: Function,
            default: () => { },
        },
    },
    data() {
        return {
            selectVisitReason: '',
            foward: ['🏆 축구선수 희망', '🤔 축구 진로 상담', '🏟️ 축구팀 입단', '🏃🏼 현) 엘리트 선수', '🏃🏼 전) 엘리트 선수'],
            midfielder: ['🥅 개인훈련', '👬🏻 단체훈련'],
            defense_n_keeper: ['🏃🏻 경기 뛰기', '🕵️‍♂️ 용병 찾기', '👬 멤버 모집하기', '🏟️ 축구팀 찾기'],
            PROFILE_BOX_LIST: PROFILE_BOX_LIST
        }
    },
    methods: {
        setSelectVisitReason(visitReason) {
            this.selectVisitReason = visitReason
        },
        async save() {
            this.$GlobalStore.showProgress()

            const formData = new FormData()
            this.selectVisitReason = this.selectVisitReason.split(' ')
            this.selectVisitReason.splice(0, 1)

            formData.append('visit_reason', this.selectVisitReason.join(' '))
            formData.append('is_pass_short_request', 'true');

            const res = await this.$Axios.post('/api/profile/save', formData, { headers: { 'Content-Type': 'multipart/form-data' } });

            if (res.data.code === ResponseCode.SUCCESS) {
                this.selectVisitReason = ''
                this.$GlobalStore.hideProgress()
                this.closeCompleteAction(PROFILE_BOX_LIST.VISIT_REASONS, true, false, true)
            }
        }
    },
    watch: {
        isOpen(newVal) {
            if (!newVal) {
                this.selectVisitReason = ''
            }
        }
    },
    created() {
        this.save = this.$Once(this.save)
    }
}
</script>

<style scoped>
.common_box {
    padding: 10px;
    border-radius: 12px;
    background-color: #f5f5f5;
    margin-top: 40px;
}

.save_btn_active {
    height: 48px;
    line-height: 48px;
    border-radius: 12px;
    background-color: #210f03;
    text-align: center;
    color: #fff;
    font-size: 14px;
    font-weight: 500;
    margin-top: 12px;
}

.save_btn_unactive {
    height: 48px;
    line-height: 48px;
    border-radius: 12px;
    background-color: #f5f5f5;
    text-align: center;
    color: #d9d9d9;
    font-size: 14px;
    font-weight: 500;
    margin-top: 12px;
}

.active {
    background-color: #210f03;
    color: #fff;
}
</style>